import { ONBOARDING_SCOPES } from '../scopeConstants';
export const TRIAL_MARKETING_HUB_PROFESSIONAL = 'trial-marketing-hub-professional';
export const TRIAL_SALES_HUB_PROFESSIONAL = 'trial-sales-hub-professional';
export const TRIAL_SERVICE_HUB_PROFESSIONAL = 'trial-service-hub-professional';
export const TRIAL_CMS_HUB_PROFESSIONAL = 'trial-cms-hub-professional';
export const TRIAL_COMMERCE_HUB_PROFESSIONAL = 'trial-commerce-hub-professional';
export const TRIAL_OPERATIONS_HUB_PROFESSIONAL = 'trial-operations-hub-professional';
export const TRIAL_MARKETING_HUB_ENTERPRISE = 'trial-marketing-hub-enterprise';
export const TRIAL_SALES_HUB_ENTERPRISE = 'trial-sales-hub-enterprise';
export const TRIAL_SERVICE_HUB_ENTERPRISE = 'trial-service-hub-enterprise';
export const TRIAL_CMS_HUB_ENTERPRISE = 'trial-cms-hub-enterprise';
export const TRIAL_COMMERCE_HUB_ENTERPRISE = 'trial-commerce-hub-enterprise';
export const TRIAL_OPERATIONS_HUB_ENTERPRISE = 'trial-operations-hub-enterprise';
export const TRIAL_HSOC_CORE_SEAT_PROFESSIONAL = 'hsoc-core-seat-professional-alpha-trial';
export const TRIAL_HSOC_CORE_SEAT_ENTERPRISE = 'hsoc-core-seat-enterprise-alpha-trial';
export const TRIAL_HSOC_FRONT_OFFICE_SEATS_PROFESSIONAL = 'hsoc-front-office-seats-professional-alpha-trial';
export const TRIAL_HSOC_FRONT_OFFICE_SEATS_ENTERPRISE = 'hsoc-front-office-seats-enterprise-alpha-trial';
export const TRIAL_SCOPES = {
  TRIAL_MARKETING_HUB_PROFESSIONAL,
  TRIAL_SALES_HUB_PROFESSIONAL,
  TRIAL_SERVICE_HUB_PROFESSIONAL,
  TRIAL_CMS_HUB_PROFESSIONAL,
  TRIAL_COMMERCE_HUB_PROFESSIONAL,
  TRIAL_OPERATIONS_HUB_PROFESSIONAL,
  TRIAL_MARKETING_HUB_ENTERPRISE,
  TRIAL_SALES_HUB_ENTERPRISE,
  TRIAL_SERVICE_HUB_ENTERPRISE,
  TRIAL_CMS_HUB_ENTERPRISE,
  TRIAL_COMMERCE_HUB_ENTERPRISE,
  TRIAL_OPERATIONS_HUB_ENTERPRISE,
  TRIAL_HSOC_CORE_SEAT_PROFESSIONAL,
  TRIAL_HSOC_CORE_SEAT_ENTERPRISE,
  TRIAL_HSOC_FRONT_OFFICE_SEATS_PROFESSIONAL,
  TRIAL_HSOC_FRONT_OFFICE_SEATS_ENTERPRISE
};
export const PRO_TRIAL_SCOPES = [TRIAL_MARKETING_HUB_PROFESSIONAL, TRIAL_SALES_HUB_PROFESSIONAL, TRIAL_SERVICE_HUB_PROFESSIONAL, TRIAL_CMS_HUB_PROFESSIONAL, TRIAL_COMMERCE_HUB_PROFESSIONAL, TRIAL_OPERATIONS_HUB_PROFESSIONAL, TRIAL_HSOC_CORE_SEAT_PROFESSIONAL, TRIAL_HSOC_FRONT_OFFICE_SEATS_PROFESSIONAL];
export const ENTERPRISE_TRIAL_SCOPES = [TRIAL_MARKETING_HUB_ENTERPRISE, TRIAL_SALES_HUB_ENTERPRISE, TRIAL_SERVICE_HUB_ENTERPRISE, TRIAL_CMS_HUB_ENTERPRISE, TRIAL_COMMERCE_HUB_ENTERPRISE, TRIAL_OPERATIONS_HUB_ENTERPRISE, TRIAL_HSOC_CORE_SEAT_ENTERPRISE, TRIAL_HSOC_FRONT_OFFICE_SEATS_ENTERPRISE];
export const ALL_TRIAL_SCOPES = [...PRO_TRIAL_SCOPES, ...ENTERPRISE_TRIAL_SCOPES];
export const ONBOARDING_SCOPES_TO_TRIAL_SCOPES = {
  [ONBOARDING_SCOPES.MARKETING_PRO]: TRIAL_MARKETING_HUB_PROFESSIONAL,
  [ONBOARDING_SCOPES.SALES_PRO]: TRIAL_SALES_HUB_PROFESSIONAL,
  [ONBOARDING_SCOPES.SERVICE_PRO]: TRIAL_SERVICE_HUB_PROFESSIONAL,
  [ONBOARDING_SCOPES.CMS_PRO]: TRIAL_CMS_HUB_PROFESSIONAL,
  [ONBOARDING_SCOPES.COMMERCE_PRO]: TRIAL_COMMERCE_HUB_PROFESSIONAL,
  [ONBOARDING_SCOPES.OPS_PRO]: TRIAL_OPERATIONS_HUB_PROFESSIONAL,
  [ONBOARDING_SCOPES.MARKETING_ENTERPRISE]: TRIAL_MARKETING_HUB_ENTERPRISE,
  [ONBOARDING_SCOPES.SALES_ENTERPRISE]: TRIAL_SALES_HUB_ENTERPRISE,
  [ONBOARDING_SCOPES.SERVICE_ENTERPRISE]: TRIAL_SERVICE_HUB_ENTERPRISE,
  [ONBOARDING_SCOPES.CMS_ENTERPRISE]: TRIAL_CMS_HUB_ENTERPRISE,
  [ONBOARDING_SCOPES.COMMERCE_ENTERPRISE]: TRIAL_COMMERCE_HUB_ENTERPRISE,
  [ONBOARDING_SCOPES.OPS_ENTERPRISE]: TRIAL_OPERATIONS_HUB_ENTERPRISE
};